let envs = {
    "local": {
        CLAIM_REDIRECT_URL: "https://www.gbsprotectall.com/login_jwt.a5w?claimid=",
        VALID_TOKEN: "485cb3a8-48cd-4981-b900-66c16b1c0215",
        API_URL: "http://localhost:3000/dev/v1",
        API_PATH_GET_CUSTOMER_BY_PHONE: "/get_customers_by_phone/{phoneNumber}",
        API_PATH_GET_CUSTOMER_BY_CUST_ID: "/get_plans_by_cust_id/{custId}",
        API_PATH_GET_CUSTOMER_BY_CUST_WARR_ID: "/get_claims_by_cust_warr_id/{custId}/{warrId}",
        USERNAME: "admin",
        PASSWORD: "secret",
    },
    "development": {
        CLAIM_REDIRECT_URL: "https://www.gbsprotectall.com/login_jwt.a5w?claimid=",
        VALID_TOKEN: "485cb3a8-48cd-4981-b900-66c16b1c0215",
        API_URL: "https://dev-api.myprotectall.com/core_api/v1",
        API_PATH_GET_CUSTOMER_BY_PHONE: "/get_customers_by_phone/{phoneNumber}",
        API_PATH_GET_CUSTOMER_BY_CUST_ID: "/get_plans_by_cust_id/{custId}",
        API_PATH_GET_CUSTOMER_BY_CUST_WARR_ID: "/get_claims_by_cust_warr_id/{custId}/{warrId}",
        USERNAME: "admin",
        PASSWORD: "secret",
    },
    "uat": {
        CLAIM_REDIRECT_URL: "https://www.gbsprotectall.com/login_jwt.a5w?claimid=",
        VALID_TOKEN: "485cb3a8-48cd-4981-b900-66c16b1c0215",
        API_URL: "https://uat-api.myprotectall.com/core_api/v1",
        API_PATH_GET_CUSTOMER_BY_PHONE: "/get_customers_by_phone/{phoneNumber}",
        API_PATH_GET_CUSTOMER_BY_CUST_ID: "/get_plans_by_cust_id/{custId}",
        API_PATH_GET_CUSTOMER_BY_CUST_WARR_ID: "/get_claims_by_cust_warr_id/{custId}/{warrId}",
        USERNAME: "admin",
        PASSWORD: "secret",
    },
    "production": {
        CLAIM_REDIRECT_URL: "https://www.gbsprotectall.com/login_jwt.a5w?claimid=",
        VALID_TOKEN: "485cb3a8-48cd-4981-b900-66c16b1c0215",
        API_URL: "https://api.myprotectall.com/core_api/v1",
        API_PATH_GET_CUSTOMER_BY_PHONE: "/get_customers_by_phone/{phoneNumber}",
        API_PATH_GET_CUSTOMER_BY_CUST_ID: "/get_plans_by_cust_id/{custId}",
        API_PATH_GET_CUSTOMER_BY_CUST_WARR_ID: "/get_claims_by_cust_warr_id/{custId}/{warrId}",
        USERNAME: "admin",
        PASSWORD: "secret",
    }
}

export default envs[process.env.REACT_APP_ENV]